import { render, staticRenderFns } from "./ExerciseIntro.vue?vue&type=template&id=4a0ad22a&scoped=true"
import script from "./ExerciseIntro.vue?vue&type=script&lang=js"
export * from "./ExerciseIntro.vue?vue&type=script&lang=js"
import style0 from "./ExerciseIntro.vue?vue&type=style&index=0&id=4a0ad22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ad22a",
  null
  
)

export default component.exports